import styled from "@emotion/styled"
import { Box, Flex } from "@rebass/grid/emotion"

export const Wrap = styled(Box)`
  padding-bottom: 40px;
  cursor: pointer;

  .line-graphic-box {
    margin-bottom: 8px;

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: -1;
    }
  }
`

export const FlexContainer = styled(Flex)`
  align-items: center;
  gap: 16px;
  padding-bottom: 8px;

  @media (min-width: 1024px) {
    gap: 32px;
  }

  .img-box,
  img {
    min-width: 115px;
    width: 115px;
    height: 88px;

    @media (min-width: 768px) {
      min-width: 150px;
      width: 150px;
      height: 115px;
    }
  }

  button {
    margin-top: 8px;

    .textelement {
      font-size: 12px;
      line-height: 1.3 !important;

      @media (min-width: 1024px) {
        font-size: 14px;
      }
    }

    .Textlink.right {
      height: 15px;
      transform: none;

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
`
